import * as React from 'react'
import styled, { css } from 'styled-components'

import * as colors from '../../../../constants/colors'

import { Icon } from '../../Icon'
import { SpecificIconProps } from '../../types'

type Shape = 'rounded' | 'square'
type ColoredProps = SpecificIconProps & {
  $backgroundColor?: string
  $shape?: Shape
  $tint?: keyof typeof TINT
  $hoverSelector?: string
}

const TINT = {
  blue: {
    primary: colors.PRIMARY_BLUE,
    secondary: colors.PRIMARY_BLUE,
  },
  red: {
    primary: colors.PRIMARY_RED,
    secondary: colors.PRIMARY_RED,
  },
}

export { Hourglass } from './Hourglass'

export const Marketplace = styled(function Marketplace(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="marketplace" viewBox="7 5 23 23">
        <path
          d="M0.723648 14.3046L3.31568 12.7309C3.37951 12.6912 3.43189 12.6356 3.46765 12.5695C3.50341 12.5034 3.52131 12.4291 3.51958 12.354C3.51785 12.2788 3.49655 12.2055 3.45778 12.1411C3.41902 12.0767 3.36413 12.0235 3.29853 11.9869L0.637933 10.5297C0.571712 10.4926 0.496834 10.4738 0.420954 10.4752C0.345073 10.4765 0.270912 10.498 0.206052 10.5374C0.141191 10.5768 0.087957 10.6327 0.0517915 10.6994C0.0156261 10.7662 -0.00217369 10.8413 0.000211817 10.9171L0.068784 13.948C0.0711196 14.0234 0.0931359 14.0968 0.132645 14.161C0.172154 14.2253 0.227779 14.278 0.293993 14.3141C0.360207 14.3501 0.434704 14.3682 0.510079 14.3666C0.585454 14.3649 0.659083 14.3435 0.723648 14.3046Z"
          fill={colors.PRIMARY_BLUE_HOVER}
          className="play"
        />
        <path
          d="M36.4905 13.1096L36.3945 11.649C36.3896 11.5896 36.404 11.5302 36.4355 11.4795C36.467 11.4289 36.5139 11.3898 36.5694 11.3679L37.9408 10.8262C37.996 10.8036 38.0426 10.7643 38.0742 10.7138C38.1058 10.6633 38.1208 10.6042 38.117 10.5447C38.1132 10.4852 38.0909 10.4285 38.0531 10.3824C38.0154 10.3363 37.9641 10.3033 37.9065 10.2879L36.4905 9.92786C36.4327 9.91317 36.3808 9.88087 36.3421 9.83542C36.3034 9.78996 36.2798 9.73361 36.2745 9.67415L36.1785 8.21356C36.1737 8.15454 36.1506 8.09848 36.1125 8.0532C36.0743 8.00792 36.023 7.97567 35.9656 7.96096C35.9082 7.94624 35.8477 7.94978 35.7925 7.97109C35.7372 7.9924 35.69 8.03042 35.6574 8.07984L34.8791 9.31757C34.8465 9.36816 34.7989 9.40728 34.7429 9.42942C34.6869 9.45155 34.6254 9.45561 34.5671 9.441L33.151 9.09814C33.0932 9.08409 33.0323 9.08855 32.9771 9.1109C32.9219 9.13325 32.8751 9.17236 32.8433 9.22272C32.8115 9.27308 32.7963 9.33215 32.7998 9.39161C32.8034 9.45107 32.8255 9.50792 32.863 9.55415L33.7853 10.6616C33.8257 10.7086 33.8498 10.7673 33.8541 10.829C33.8584 10.8908 33.8427 10.9523 33.8093 11.0044L33.031 12.2387C32.9977 12.289 32.9813 12.3487 32.9845 12.409C32.9876 12.4692 33.0101 12.5269 33.0485 12.5734C33.087 12.6199 33.1394 12.6529 33.198 12.6673C33.2566 12.6817 33.3182 12.6769 33.3739 12.6536L34.7454 12.1119C34.8008 12.089 34.8621 12.0846 34.9202 12.0994C34.9783 12.1143 35.03 12.1475 35.0676 12.1942L36.0036 13.3188C36.0439 13.3595 36.0954 13.3871 36.1515 13.3981C36.2077 13.409 36.2658 13.4028 36.3184 13.3802C36.371 13.3576 36.4155 13.3197 36.4462 13.2715C36.4769 13.2232 36.4923 13.1668 36.4905 13.1096Z"
          fill={colors.PRIMARY_BLUE_HOVER}
          className="star"
        />
        <path
          d="M27.3457 7.13642C27.8172 7.13642 28.1994 6.75419 28.1994 6.28269C28.1994 5.8112 27.8172 5.42897 27.3457 5.42897C26.8742 5.42897 26.4919 5.8112 26.4919 6.28269C26.4919 6.75419 26.8742 7.13642 27.3457 7.13642Z"
          fill={colors.PRIMARY_BLUE_HOVER}
          className="round"
        />
        <path
          d="M6.84516 30.5534L6.84501 30.5534C6.51787 30.5519 6.20473 30.4206 5.97438 30.1883C5.74404 29.956 5.61531 29.6418 5.6165 29.3147C5.6165 29.3147 5.6165 29.3146 5.6165 29.3146L5.64231 25.0457L5.64231 25.0457L5.73466 10.9908C5.73466 10.9906 5.73466 10.9905 5.73466 10.9904C5.73744 10.7714 5.82683 10.5624 5.9833 10.4091L5.9833 10.4091L5.98439 10.408C6.06054 10.3315 6.15115 10.271 6.25095 10.23C6.35077 10.1889 6.45776 10.1682 6.56567 10.169L6.56579 10.169L10.9072 10.1974L11.0314 10.1982L11.033 10.074L11.0782 6.57492L11.0782 6.5743C11.0879 5.36178 11.578 4.20256 12.441 3.35082C13.3041 2.49911 14.4696 2.02437 15.6821 2.03069C16.3085 2.03504 16.9274 2.16784 17.5005 2.42089L17.5502 2.44283L17.6001 2.42149C18.1786 2.17426 18.8014 2.04762 19.4306 2.04932C20.6397 2.06643 21.7931 2.56059 22.6396 3.42421C23.4863 4.28798 23.9573 5.45135 23.95 6.66084L23.9243 10.1486L23.9234 10.273L24.0478 10.2745L24.2974 10.2774L24.2982 10.2775L29.5096 10.3062L29.5098 10.3062C29.7293 10.3071 29.9395 10.3952 30.0942 10.551C30.2488 10.7068 30.3353 10.9177 30.3347 11.1372L30.2303 29.861L30.2303 29.8612C30.2293 30.0807 30.1413 30.2909 29.9855 30.4456C29.8298 30.6001 29.6191 30.6866 29.3996 30.6861C29.3995 30.6861 29.3994 30.6861 29.3993 30.6861L24.1752 30.655L24.1746 30.7706L24.1752 30.655L6.84516 30.5534ZM22.2597 10.1404L22.284 6.75623L22.3008 6.75388L22.3014 6.64576C22.3053 5.87302 22.0027 5.13026 21.4598 4.58032C20.917 4.03038 20.1782 3.71815 19.4055 3.7121L19.1559 3.71014L19.3038 3.91118C19.8853 4.70142 20.1955 5.65854 20.1882 6.63962L20.162 10.1234L20.161 10.2483L20.2859 10.2493L22.1337 10.2645L22.2588 10.2655L22.2597 10.1404ZM17.3168 4.55004L17.3168 4.55001L17.3143 4.5524C17.0391 4.8205 16.8203 5.14084 16.6706 5.49466C16.5208 5.84847 16.4433 6.22861 16.4425 6.61279L16.4232 10.1163L16.4225 10.2411L16.5474 10.2419L18.3863 10.2541L18.5112 10.2549L18.5121 10.1301L18.5384 6.64738C18.5384 6.64721 18.5384 6.64703 18.5384 6.64685C18.5445 6.26005 18.4729 5.87597 18.3278 5.51736C18.1827 5.15859 17.967 4.83262 17.6934 4.55882L17.6936 4.55868L17.6883 4.55394L17.582 4.45905L17.4974 4.38345L17.414 4.46038L17.3168 4.55004ZM12.689 6.59044L12.689 6.59097L12.6917 10.0706L12.6918 10.1945L12.8157 10.1955L14.6634 10.2107L14.7896 10.2117L14.7895 10.0856L14.7856 6.59864C14.7856 6.59845 14.7856 6.59825 14.7856 6.59806C14.7926 5.62081 15.1149 4.67194 15.7046 3.89257L15.8549 3.69392L15.6058 3.69216C15.2261 3.68947 14.8497 3.76227 14.4984 3.90634C14.1474 4.05032 13.8285 4.26259 13.5602 4.53083C13.2857 4.79909 13.0673 5.11927 12.9177 5.47274C12.7681 5.82643 12.6903 6.20638 12.689 6.59044Z"
          fill={colors.PRIMARY_BLACK}
          stroke={colors.PRIMARY_BLUE_HOVER}
          strokeWidth="0.25"
        />
        <path
          d="M7.14935 28.783L7.14782 29.0332L7.39803 29.0345L23.2347 29.1176L23.4844 29.1189L23.486 28.8692L23.5963 12.0532L23.598 11.8032L23.348 11.8016L7.50378 11.6942L7.25361 11.6925L7.25209 11.9427L7.14935 28.783Z"
          fill={colors.PRIMARY_WHITE}
          stroke={colors.PRIMARY_WHITE}
          strokeWidth="0.5"
        />
        <g clipPath="url(#clip0_7191_12800)">
          <path
            d="M16.3989 16.3838L13.8235 18.9592C13.6515 19.1312 13.5539 19.3683 13.5539 19.6147V24.2588C13.5539 24.7701 13.9723 25.1885 14.4836 25.1885H18.6675C19.0394 25.1885 19.3741 24.9654 19.5229 24.626L21.0384 21.0883C21.4289 20.1679 20.7548 19.1452 19.7553 19.1452H17.1288L17.5704 17.016C17.6169 16.7836 17.5472 16.5465 17.3798 16.3792C17.1055 16.1095 16.6686 16.1095 16.3989 16.3838V16.3838ZM11.6944 25.1885C12.2058 25.1885 12.6241 24.7701 12.6241 24.2588V20.5398C12.6241 20.0284 12.2058 19.61 11.6944 19.61C11.183 19.61 10.7646 20.0284 10.7646 20.5398V24.2588C10.7646 24.7701 11.183 25.1885 11.6944 25.1885Z"
            fill={colors.PRIMARY_BLUE_HOVER}
          />
        </g>
        <defs>
          <clipPath id="clip0_7191_12800">
            <rect width="11.157" height="11.157" fill="white" transform="translate(10.2983 15.4257)" />
          </clipPath>
        </defs>
      </Icon>
    </Wrapper>
  )
})`
  overflow: visible;

  .play,
  .star,
  .round {
    transition: 0.3s;
  }

  ${(props) => props.$hoverSelector} & {
    cursor: pointer;
  }

  ${(props) => props.$hoverSelector}:hover & {
    .play {
      transform: translate(-3px, -2px);
    }

    .round {
      transform: translate(1px, -0.5px);
    }

    .star {
      transform: translate(2px, -2px);
    }
  }
`

export const Company = styled(function Company(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="company" viewBox="5 0 23 23">
        <g className="paper">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.936.983c.25-.21.579-.324.928-.293L17.797 1.91a1.27 1.27 0 0 1 1.157 1.38l-1.797 20.576a1.268 1.268 0 0 1-1.378 1.157L1.847 23.803a1.27 1.27 0 0 1-1.158-1.38L2.487 1.848c.03-.35.2-.655.449-.864Z"
            fill={colors.PRIMARY_BLACK}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.805 1.373a.583.583 0 0 0-.635.533L1.373 22.483a.585.585 0 0 0 .535.637l13.931 1.222a.584.584 0 0 0 .636-.534l1.797-20.576a.585.585 0 0 0-.535-.638L3.806 1.373ZM2.495.458c.384-.321.892-.497 1.43-.45l13.932 1.221a1.956 1.956 0 0 1 1.78 2.121L17.84 23.927a1.953 1.953 0 0 1-2.12 1.78L1.788 24.486a1.955 1.955 0 0 1-1.33-.693 1.955 1.955 0 0 1-.45-1.428L1.804 1.788a1.953 1.953 0 0 1 .69-1.33Z"
            fill={colors.PRIMARY_BLACK}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.114 2.077c.404-.034.785.098 1.073.34.288.242.484.593.52.996l1.776 20.19a1.462 1.462 0 0 1-1.332 1.59L4.273 26.575a1.469 1.469 0 0 1-1.073-.34 1.468 1.468 0 0 1-.52-.996L.905 5.048a1.462 1.462 0 0 1 1.332-1.59l15.877-1.38Z"
            fill={colors.PRIMARY_WHITE}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.174 2.76 2.296 4.14a.777.777 0 0 0-.71.847l.001.001 1.775 20.19a.784.784 0 0 0 .852.714l15.876-1.38h.001a.777.777 0 0 0 .709-.847l-1.775-20.19a.783.783 0 0 0-.279-.533.784.784 0 0 0-.573-.182Zm-.117-1.365c.592-.051 1.15.143 1.571.497.421.353.71.869.763 1.46v.001l1.775 20.19a2.148 2.148 0 0 1-1.954 2.334h-.001l-15.878 1.38h-.001a2.154 2.154 0 0 1-1.572-.497 2.154 2.154 0 0 1-.762-1.46L.223 5.11v-.001a2.148 2.148 0 0 1 1.954-2.333l15.88-1.381Z"
            fill={colors.PRIMARY_BLACK}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m5.822 6.822 10.001-.87a.687.687 0 0 1 .743.622l.014.158a.684.684 0 0 1-.623.742l-10.001.871a.687.687 0 0 1-.743-.623L5.2 7.564a.684.684 0 0 1 .622-.742h.001ZM6.09 9.868l10.001-.871a.687.687 0 0 1 .743.623l.014.158a.685.685 0 0 1-.622.742h-.001l-10.001.87a.687.687 0 0 1-.743-.623l-.014-.157a.684.684 0 0 1 .623-.742ZM6.358 12.913l10-.871a.687.687 0 0 1 .744.623l.013.158a.684.684 0 0 1-.622.742l-10.001.87a.687.687 0 0 1-.743-.623l-.014-.157a.684.684 0 0 1 .623-.742ZM12.309 15.463l4.318-.375a.687.687 0 0 1 .742.623l.014.157a.684.684 0 0 1-.622.743l-4.318.375a.687.687 0 0 1-.743-.623l-.014-.157a.684.684 0 0 1 .622-.743Z"
            fill={colors.PRIMARY_BLACK}
          />
        </g>
        <g className="certif">
          <path
            d="M24.367 12.094A4.391 4.391 0 1 0 19.475 4.8a4.391 4.391 0 0 0 4.892 7.294Z"
            fill={colors.PRIMARY_BLUE_HOVER}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.714 10.906a4.372 4.372 0 0 1-1.83 2.309 4.376 4.376 0 0 1-3.17.586l4.049 9.147a.459.459 0 0 0 .834.007l1.598-3.436a1.008 1.008 0 0 1 .932-.584l3.715.067a.459.459 0 0 0 .352-.761l-6.48-7.335Z"
            fill={colors.PRIMARY_BLUE_HOVER}
          />
        </g>
      </Icon>
    </Wrapper>
  )
})`
  overflow: visible;

  .certif,
  .paper {
    transition: 0.3s;
  }

  ${(props) => props.$hoverSelector} & {
    cursor: pointer;
  }

  ${(props) => props.$hoverSelector}:hover & {
    .certif {
      transform: rotate(-5deg);
    }

    .paper {
      transform: rotate(5deg);
    }
  }
`

// Deprecated
export const Discover = styled(function Discover(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="discovered">
        <circle
          cx="16"
          cy="15.996"
          r="14.316"
          fill={props.$tint ? TINT[props.$tint]?.secondary : colors.PRIMARY_WHITE}
          fillOpacity=".4"
        />
        <path
          d="M16 0C7.175 0 0 7.175 0 16s7.175 16 16 16 16-7.175 16-16S24.825 0 16 0Zm0 29.777C8.421 29.777 2.223 23.579 2.223 16 2.223 8.421 8.421 2.223 16 2.223c7.579 0 13.777 6.198 13.777 13.777 0 7.579-6.198 13.777-13.777 13.777Z"
          fill={props.$tint ? TINT[props.$tint]?.primary : colors.GREY_SHADE_7}
        />
        <path
          d="m20.648 7.87-8.05 3.2a2.67 2.67 0 0 0-1.483 1.482l-3.2 8.05c-.404 1.01-.168 2.088.607 2.863a2.63 2.63 0 0 0 1.852.775c.337 0 .674-.067 1.01-.202l8.052-3.2a2.67 2.67 0 0 0 1.482-1.482l3.2-8.05c.404-1.011.168-2.089-.607-2.864-.774-.741-1.853-.977-2.863-.573Zm1.381 2.627-3.2 8.05a.407.407 0 0 1-.236.236l-8.05 3.2c-.236.101-.404-.033-.472-.1a.412.412 0 0 1-.101-.472l3.2-8.05a.407.407 0 0 1 .236-.237l8.05-3.2c.068-.033.101-.033.169-.033.134 0 .236.067.303.134.067.101.202.27.101.472Z"
          fill={props.$tint ? TINT[props.$tint]?.primary : colors.GREY_SHADE_7}
        />
        <path
          d="M17.89 15.997a1.886 1.886 0 1 1-3.772 0 1.886 1.886 0 0 1 3.773 0Z"
          fill={props.$tint ? TINT[props.$tint]?.primary : colors.GREY_SHADE_7}
        />
      </Icon>
    </Wrapper>
  )
})``

export const Education = styled(function Education(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="education" viewBox="10 10 23 23">
        <g className="content">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.562 29.206c-2.948 2.17-5.98 3.392-9.093 3.664-3.117.273-6.317-.405-9.6-2.033a.733.733 0 0 1-.404-.586l-.654-6.708a.733.733 0 0 1 .895-.785l8.398 1.94c.404.092.827.055 1.208-.108l7.873-3.365a.733.733 0 0 1 1.018.603l.654 6.717a.733.733 0 0 1-.295.661Z"
            fill={colors.PRIMARY_WHITE}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m30.006 28.562-.633-6.495-7.727 3.303a2.803 2.803 0 0 1-1.733.154l-8.242-1.904.632 6.485c3.147 1.55 6.173 2.175 9.092 1.92 2.916-.255 5.784-1.394 8.611-3.463Zm-18.491-4.978Zm19.55 6.306c-3.052 2.246-6.228 3.537-9.522 3.825-3.297.289-6.652-.433-10.051-2.118l.345-.697-.345.697a1.581 1.581 0 0 1-.872-1.264l-.653-6.708a1.582 1.582 0 0 1 1.93-1.694l8.398 1.94c.229.052.468.031.684-.061l7.873-3.365a1.582 1.582 0 0 1 2.195 1.3l.655 6.718a1.581 1.581 0 0 1-.637 1.427Z"
            fill={colors.PRIMARY_BLACK}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m19.536 12.643 13.426 2.819a1.955 1.955 0 0 1 .326 3.727l-12.732 5.108a1.955 1.955 0 0 1-1.13.1L6 21.576a1.955 1.955 0 0 1-.327-3.728l12.733-5.108a1.955 1.955 0 0 1 1.13-.098Z"
            fill={colors.PRIMARY_WHITE}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.643 17.602a1.106 1.106 0 0 0-.855-1.31L19.36 13.473a1.107 1.107 0 0 0-.639.056L5.989 18.637a1.106 1.106 0 0 0 .185 2.11L19.6 23.565c.214.045.436.025.64-.056l12.732-5.108c.343-.138.595-.438.671-.8Zm-.507-2.97a2.803 2.803 0 0 1 .468 5.345l-12.733 5.108a2.803 2.803 0 0 1-1.62.142l-13.426-2.82a2.803 2.803 0 0 1-.468-5.345l12.733-5.108a2.804 2.804 0 0 1 1.62-.142l13.426 2.82Z"
            fill={colors.PRIMARY_BLACK}
          />
          <path
            d="M34.234 19.58c-.035-.41-.116-.74-.18-.734-.063.006-.086.343-.05.754l.634 7.248c.036.41.117.74.18.734.064-.006.087-.343.05-.754l-.634-7.248Z"
            fill={colors.PRIMARY_WHITE}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.315 18.412a.878.878 0 0 1 .666-.411.878.878 0 0 1 .728.29c.09.099.14.2.164.25.052.11.085.227.107.314.045.186.08.416.1.65l.635 7.25c.02.234.026.466.013.658-.006.09-.018.21-.05.327a1.011 1.011 0 0 1-.118.276.878.878 0 0 1-.667.41.878.878 0 0 1-.728-.288c-.09-.1-.14-.2-.164-.25a1.714 1.714 0 0 1-.106-.315 4.462 4.462 0 0 1-.101-.65l-.634-7.25a4.475 4.475 0 0 1-.014-.658c.006-.09.018-.21.05-.328.015-.054.047-.161.119-.275Z"
            fill={colors.PRIMARY_BLACK}
          />
          <path
            d="M11.083 25.767v-2.639l9.5 1.584 8.973-3.695v2.64l-8.045 3.785a3 3 0 0 1-1.928.214l-8.5-1.889Z"
            fill={colors.PRIMARY_BLACK}
          />
        </g>
        <path
          d="M7.296 11.84a.862.862 0 0 0 1.055.15.86.86 0 0 0 .412-.983l-.885-3.345a.863.863 0 0 0-.506-.582.868.868 0 0 0-.77.047l-1.523.87a.867.867 0 0 0-.432.636c-.038.27.05.536.24.73l2.41 2.478ZM.684 13.878l3.19 1.323a.864.864 0 0 0 1.028-.277.86.86 0 0 0-.008-1.065l-2.136-2.726a.864.864 0 0 0-.694-.334.86.86 0 0 0-.687.348L.319 12.548a.87.87 0 0 0 .365 1.33Z"
          fill={colors.PRIMARY_BLUE_HOVER}
          className="shards"
        />
      </Icon>
    </Wrapper>
  )
})`
  overflow: visible;

  .shards,
  .content {
    transition: 0.3s;
  }

  ${(props) => props.$hoverSelector} & {
    cursor: pointer;
  }

  ${(props) => props.$hoverSelector}:hover & {
    .shards {
      transform: translate(-2px, -5px);
    }

    .content {
      transform: translate(0px, -1px) rotate(-5deg);
    }
  }
`

export const Egg = styled(function Egg(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="egg" viewBox="0 5 23 23">
        <g className="egg">
          <path
            d="m7.075 13.569 4.013-5.975 4.193 2.31 2.859-4.256c-.228-.23-.46-.454-.698-.665-2.637-2.331-5.636-3.275-8.444-2.655l-.004.001c-3.771.835-6.28 4.467-6.851 9.134l4.932 2.106ZM16.435 17.308l-3.388-3.405-5.199 5.224L2.79 15.02c-.419 1.734-.649 3.61-.647 5.569 0 3.123 1.062 5.988 2.985 8.064a9.845 9.845 0 0 0 7.299 3.197h.006c2.809-.001 5.4-1.128 7.3-3.17 1.921-2.069 2.98-4.947 2.977-8.104-.001-2.926-.495-5.725-1.416-8.15l-4.859 4.88Z"
            fill={colors.PRIMARY_WHITE}
          />
          <path
            d="M21.247 12.038a.46.46 0 0 0-.746-.157l-2.174 2.135-1.867-1.626a.46.46 0 0 0-.62.015l-2.01 1.945-1.027-1.008a.459.459 0 0 0-.642 0l-.784.77-2.73-2.102 2.489-4.019 3.817 2.28a.46.46 0 0 0 .624-.15l2.866-4.63a.44.44 0 0 0-.05-.53 15.79 15.79 0 0 0-.72-.743C14.912 1.57 11.754.504 8.78 1.215l-.005.001c-3.834.92-6.598 4.876-7.213 10.321a.442.442 0 0 0 .258.453l2.99 1.385-1.368 1.874-1.048-.832a.46.46 0 0 0-.727.242A23.316 23.316 0 0 0 1 20.269c.003 3.203 1.117 6.142 3.141 8.279 2.018 2.13 4.758 3.303 7.721 3.303 2.967 0 5.706-1.165 7.714-3.277 2.022-2.128 3.136-5.083 3.134-8.318-.002-2.915-.508-5.757-1.463-8.218ZM2.505 11.32c.637-4.9 3.105-8.425 6.486-9.236l.003-.001c2.66-.636 5.515.35 8.043 2.774.142.136.291.288.452.457l-2.453 3.963-3.816-2.28a.46.46 0 0 0-.624.149L6.784 13.3 2.505 11.32Zm16.406 16.647c-1.833 1.929-4.337 2.992-7.055 2.993-2.702 0-5.206-1.072-7.05-3.02-1.866-1.97-2.895-4.695-2.896-7.67a22.667 22.667 0 0 1 .483-4.709l4.548 3.61a.46.46 0 0 0 .606-.032l4.937-4.85 3.106 3.05c.17.167.472.167.642 0l4.408-4.33c.76 2.205 1.16 4.695 1.162 7.247 0 3.01-1.026 5.748-2.89 7.711Z"
            fill={colors.PRIMARY_BLACK}
            stroke={colors.PRIMARY_BLACK}
            strokeWidth=".5"
          />
        </g>
        <path
          d="M29.415 22.22c-1.427-.41-2.878.094-3.796 1.177-.292-1.431-1.314-2.648-2.74-3.06-2.025-.582-4.098.676-4.63 2.812-1.247 5.004 3.104 11.19 4.54 11.604 1.434.413 8.237-3.234 9.327-7.61.533-2.135-.677-4.34-2.701-4.922Z"
          fill={colors.PRIMARY_BLUE_HOVER}
          className="heart"
        />
      </Icon>
    </Wrapper>
  )
})`
  overflow: visible;

  .egg,
  .heart {
    transition: 0.3s;
  }

  ${(props) => props.$hoverSelector} & {
    cursor: pointer;
  }

  ${(props) => props.$hoverSelector}:hover & {
    .egg {
      transform: rotate(3deg);
      transform: translate(-3px);
    }

    .heart {
      transform: rotate(-2deg);
      transform: translate(2px);
    }
  }
`

export const Search = styled(function Search(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="search" viewBox="30 30 45 45">
        <g className="magnifying-glass">
          <path
            d="m30.777 71.186 19.145-8.122c.629-.27.942-.993.7-1.64l-.162-.433 1.163-.44-1.938-5.153-1.128.425-.162-.433a1.264 1.264 0 0 0-1.59-.77l-17.21 5.732-2.474.822-3.544 1.179s-.032.008-.048.016c-2.805 1.06-4.241 4.232-3.2 7.062a5.435 5.435 0 0 0 4.15 3.482 5.361 5.361 0 0 0 2.832-.266c.016-.004.032-.012.048-.02l.957-.405 2.453-1.04.008.004Z"
            fill={colors.PRIMARY_WHITE}
          />
          <path
            d="m30.777 71.186 19.145-8.122c.629-.27.942-.993.7-1.64l-.162-.433 1.163-.44-1.938-5.153-1.128.425-.162-.433a1.264 1.264 0 0 0-1.59-.77l-17.21 5.732-2.474.822-3.544 1.179s-.032.008-.048.016c-2.805 1.06-4.241 4.232-3.2 7.062a5.435 5.435 0 0 0 4.15 3.482 5.361 5.361 0 0 0 2.832-.266c.016-.004.032-.012.048-.02l.957-.405 2.453-1.04.008.004Zm17.032-10.02-5.325 2.259-1.527-4.149 5.483-1.826 1.373 3.72-.004-.004Zm-21.396 9.079c-1.483.548-3.133-.218-3.687-1.715-.554-1.497.198-3.172 1.677-3.743l14.133-4.705 1.598 4.34-13.72 5.823Z"
            fill={colors.PRIMARY_BLACK}
          />
          <path
            d="M67.647 68.435c9.369 0 16.964-7.622 16.964-17.023s-7.595-17.023-16.965-17.023c-9.369 0-16.964 7.622-16.964 17.023s7.595 17.023 16.965 17.023Z"
            fill={colors.PRIMARY_WHITE}
          />
          <path
            d="M67.646 69.828c-10.12 0-18.35-8.261-18.35-18.412C49.297 41.266 57.53 33 67.647 33c10.117 0 18.35 8.261 18.35 18.412 0 10.15-8.233 18.412-18.35 18.412v.004Zm0-34.05c-8.593 0-15.58 7.016-15.58 15.634 0 8.619 6.991 15.633 15.58 15.633 8.59 0 15.58-7.014 15.58-15.633 0-8.618-6.986-15.633-15.58-15.633Z"
            fill={colors.PRIMARY_BLACK}
          />
        </g>
        <g className="egg">
          <path
            d="m63.99 49.542 3.957-3.97 2.516 2.524 2.82-2.827a11.651 11.651 0 0 0-.366-.638c-1.416-2.272-3.341-3.691-5.438-3.691h-.003c-2.814.002-5.273 2.572-6.559 6.113l3.072 2.489Z"
            fill={colors.PRIMARY_BLUE_HOVER}
          />
          <path
            d="m70.406 50.211-2.477-2.484-3.8 3.81-3.696-2.995a17.35 17.35 0 0 0-.474 4.063c.003 2.279.772 4.623 2.177 6.138a7.2 7.2 0 0 0 5.335 2.334h.005a7.213 7.213 0 0 0 5.335-2.313c1.406-1.508 2.185-3.862 2.182-6.167 0-2.136-.362-4.177-1.035-5.947l-3.552 3.561Z"
            fill={colors.PRIMARY_BLUE_HOVER}
          />
        </g>
      </Icon>
    </Wrapper>
  )
})`
  overflow: visible;

  .magnifying-glass,
  .egg {
    transition: 0.3s;
  }

  ${(props) => props.$hoverSelector} & {
    cursor: pointer;
  }

  ${(props) => props.$hoverSelector}:hover & {
    .magnifying-glass {
      transform: rotate(5deg);
    }

    .egg {
      transform: scale(1.3) translate(-19px, -7px);
    }
  }
`

export const Partners = styled(function Partners(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="partners" viewBox="7 2 25 25">
        <path
          d="M1.457 7.053a1.005 1.005 0 0 0-1.315.885l-.14 2.019c-.02.312.103.613.335.821a.99.99 0 0 0 .853.233l3.9-.758a.992.992 0 0 0 .809-.922.993.993 0 0 0-.681-1.02L1.453 7.053h.004ZM3.781.128a.997.997 0 0 0-.706.53L2.152 2.46a.992.992 0 0 0-.016.887.992.992 0 0 0 .693.553l3.883.85a.986.986 0 0 0 1.107-.526c.134-.268.144-.567.039-.828a1.024 1.024 0 0 0-.267-.378L4.63.368a1 1 0 0 0-.849-.24Z"
          fill={colors.PRIMARY_BLUE_HOVER}
          className="confettis"
        />
        <g className="speaker">
          <g clipPath="url(#a)">
            <path
              d="m25.642 21.17-1.365 5.66c-.282 1.174.538 2.332 1.759 2.479 1.084.13 2.084-.593 2.28-1.647l1.114-5.983"
              fill={colors.PRIMARY_WHITE}
            />
            <path
              d="M26.286 30a2.76 2.76 0 0 1-2.261-1.158c-.446-.63-.601-1.42-.422-2.167l1.364-5.66a.686.686 0 0 1 .83-.502c.369.086.6.451.51.814l-1.364 5.66c-.092.38-.016.763.21 1.081.225.32.567.52.961.568a1.37 1.37 0 0 0 1.52-1.096l1.114-5.983a.688.688 0 0 1 .802-.545.677.677 0 0 1 .554.787l-1.114 5.983C28.748 29.077 27.593 30 26.283 30h.003Z"
              fill={colors.PRIMARY_BLACK}
            />
            <path d="m31.243 15.088 4.968-.035s1.297 3.27-1.481 6.117l-4.666-2.842" fill={colors.PRIMARY_WHITE} />
            <path
              d="M34.733 21.845a.68.68 0 0 1-.362-.101L29.705 18.9a.669.669 0 0 1-.223-.93.698.698 0 0 1 .948-.22l4.172 2.54a5.241 5.241 0 0 0 1.098-4.557l-4.449.03h-.005a.682.682 0 0 1-.688-.673c0-.374.305-.678.685-.68l4.968-.035h.006a.69.69 0 0 1 .641.43c.06.149 1.422 3.706-1.625 6.828a.698.698 0 0 1-.497.208l-.003.003Z"
              fill={colors.PRIMARY_BLACK}
            />
            <path
              d="M9.563 21.285a.685.685 0 0 1-.68-.569C8.802 20.226 7 8.63 15.683.854a.698.698 0 0 1 .867-.048l16.068 11.323a.685.685 0 0 1 .261.36c.017.053 1.522 5.372-3.095 8.715a.703.703 0 0 1-.41.134l-19.814-.05.003-.003Z"
              fill={colors.PRIMARY_WHITE}
            />
            <path
              d="m16.15 1.353 16.068 11.323s1.44 4.878-2.842 7.984l-19.81-.05S7.64 8.973 16.15 1.352Zm0-1.353a1.4 1.4 0 0 0-.929.352c-3.715 3.33-6.107 7.923-6.917 13.287-.606 4.022-.12 7.058-.098 7.184a1.372 1.372 0 0 0 1.356 1.137l19.81.05h.004c.293 0 .581-.093.818-.264 4.998-3.624 3.416-9.212 3.348-9.45a1.372 1.372 0 0 0-.52-.722L16.953.254A1.387 1.387 0 0 0 16.148 0h.003Z"
              fill={colors.PRIMARY_BLACK}
            />
            <path
              d="M17.307 12.518c1.78-5.625 1.624-10.673-.348-11.274-1.97-.601-5.01 3.472-6.79 9.098-1.779 5.626-1.623 10.674.348 11.275 1.97.6 5.01-3.473 6.79-9.099Z"
              fill={colors.PRIMARY_BLACK}
            />
            <path
              d="M12.743 11.33c1.049-3.316 2.56-5.977 3.815-6.938-.163-.472-.407-.784-.733-.883-1.346-.41-3.572 2.853-4.974 7.288-1.402 4.435-1.449 8.36-.106 8.772.34.104.734-.027 1.158-.35-.506-1.47-.22-4.534.84-7.888Z"
              fill={colors.PRIMARY_WHITE}
            />
            <path
              d="M25.913 21.58a.709.709 0 0 1-.426-.143.667.667 0 0 1-.114-.95c3.848-4.801 2.772-10.539 2.761-10.597a.677.677 0 0 1 .543-.793.685.685 0 0 1 .808.534c.051.259 1.22 6.391-3.03 11.694a.696.696 0 0 1-.541.258v-.002Z"
              fill={colors.PRIMARY_BLACK}
            />
            <path d="m14.507 18.111 17.272 1.93-1.8 1.726-19.462-.149 3.99-3.506Z" fill={colors.PRIMARY_BLACK} />
          </g>
          <defs>
            <clipPath id="a">
              <path fill={colors.PRIMARY_WHITE} d="M8 0h32v30H8z" />
            </clipPath>
          </defs>
        </g>
      </Icon>
    </Wrapper>
  )
})`
  overflow: visible;

  .confettis,
  .speaker {
    transition: 0.3s;
  }

  ${(props) => props.$hoverSelector} & {
    cursor: pointer;
  }

  ${(props) => props.$hoverSelector}:hover & {
    .confettis {
      transform: translate(-4px);
    }

    .speaker {
      transform: rotate(5deg);
    }
  }
`

export const Training = styled(function Training(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="training" viewBox="5 5 23 23">
        <g clipPath="url(#a)">
          <g className="lightbulb" stroke={colors.PRIMARY_BLUE_HOVER} strokeLinecap="round">
            <path
              fill={colors.PRIMARY_BLUE_HOVER}
              strokeLinejoin="round"
              d="M21.08 8.54c0-2.53 1.74-4.15 4.21-4.15 2.8 0 4.5 1.92 4.5 4.28 0 1.2-.6 2.09-1.35 3.06a5.7 5.7 0 0 0-1.1 3.07h-4.08s.23-1.68-.65-3c-.53-.8-1.53-1.93-1.53-3.26Z"
            />
            <path
              strokeLinejoin="round"
              strokeWidth=".5"
              fill={colors.PRIMARY_WHITE}
              d="M23.54 16.19v.93c0 .36.16.65.36.65h2.9c.2 0 .36-.29.36-.65v-.93h-3.62Z"
            />
            <path
              strokeLinejoin="round"
              strokeWidth=".5"
              fill={colors.PRIMARY_WHITE}
              d="M23.2 14.97v.95c0 .22.2.4.42.4h3.36a.4.4 0 0 0 .41-.4v-.95h-4.18Z"
            />
            <path strokeMiterlimit="10" d="M25.33.97v1.65m-6.1.58 1.21 1.17M31.68 3.2l-1.21 1.17m2.76 4.17H31.5" />
          </g>
          <g className="bloc">
            <path fill={colors.PRIMARY_BLACK} d="M23.93 12.26s-.55 12.58-1.1 15.92l-2.73-.61" />
            <path
              stroke={colors.PRIMARY_BLACK}
              fill={colors.PRIMARY_WHITE}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M23.93 12.26s-.55 12.58-1.1 15.92l-2.73-.61"
            />
            <path fill={colors.PRIMARY_WHITE} d="m16.68 28.12 2.84.75s3.35-8.34 4.48-16.6" />
            <path
              fill={colors.PRIMARY_WHITE}
              stroke={colors.PRIMARY_BLACK}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m16.68 28.12 2.84.75s3.35-8.34 4.48-16.6"
            />
            <path
              fill={colors.PRIMARY_WHITE}
              d="M7 14.12c-1.8 4.17-4.26 9.32-6.06 11.3l14.74 3.9s5.47-9 8.29-17.28L9.38 8.19"
            />
            <path
              fill={colors.PRIMARY_WHITE}
              stroke={colors.PRIMARY_BLACK}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M7 14.12c-1.8 4.17-4.26 9.32-6.06 11.3l14.74 3.9s5.47-9 8.29-17.28L9.38 8.19l-2.37 5.93Z"
            />
            <path
              stroke={colors.PRIMARY_BLACK}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.5 9.87c.06-.4.13-.8.3-1.16.18-.36.5-.67.9-.75.4-.07.87.15.96.54m.42 2.05c.07-.4.13-.8.3-1.15.19-.36.5-.67.9-.75.4-.08.87.15.97.54m.65 2.11c.06-.4.13-.8.3-1.16.19-.35.5-.67.9-.74.4-.08.87.15.97.53m.74 2.14c.06-.4.13-.8.3-1.15.19-.36.5-.68.9-.75.4-.08 1 .2 1 .93M9.33 13.97l.64 1.13s1.28-1.05 2.52-1.5m-4.74 4.03.64 1.13s1.28-1.05 2.52-1.5m-4.81 4.3.63 1.13s1.29-1.05 2.53-1.5"
            />
          </g>
        </g>
        <defs>
          <clipPath id="a">
            <path fill={colors.PRIMARY_WHITE} d="M0 0h34v31H0z" />
          </clipPath>
        </defs>
      </Icon>
    </Wrapper>
  )
})`
  overflow: visible;

  .lightbulb,
  .bloc {
    transition: 0.3s;
  }

  ${(props) => props.$hoverSelector} & {
    cursor: pointer;
  }

  ${(props) => props.$hoverSelector}:hover & {
    .lightbulb {
      transform: rotate(8deg) translate(2px, -5px);
    }

    .bloc {
      transform: rotate(3deg);
    }
  }
`

// Deprecated
export const Users = styled(function Users(props: ColoredProps): React.ReactElement<ColoredProps> {
  return (
    <Wrapper $backgroundColor={props.$backgroundColor} $shape={props.$shape ?? 'rounded'}>
      <Icon {...props} name="users">
        <path
          d="M16 19c9.378 0 14 4.145 14 11.326 0 .861-.696 1.56-1.556 1.56-.859 0-1.555-.699-1.555-1.56C25.532 31.886 23.733 34 16 34c-7.733 0-9.617-2.114-10.889-3.674 0 .861-.696 1.56-1.555 1.56-.86 0-1.556-.699-1.556-1.56C2 23.145 6.622 19 16 19ZM16 0c4.8 0 8 3.2 8 8 0 4.708-2.946 7.807-7.424 7.99l-.265.008L16 16c-4.8 0-8-3.2-8-8s3.2-8 8-8Z"
          fill={props.$tint ? TINT[props.$tint]?.secondary : colors.PRIMARY_WHITE}
          fillOpacity=".4"
        />
        <path
          d="M16 19c9.378 0 14 4.182 14 11.426 0 .87-.696 1.574-1.556 1.574-.859 0-1.555-.705-1.555-1.574 0-5.423-3.156-8.279-10.889-8.279-7.733 0-10.889 2.856-10.889 8.28 0 .868-.696 1.573-1.555 1.573C2.696 32 2 31.295 2 30.426 2 23.182 6.622 19 16 19ZM16 0c4.8 0 8 3.2 8 8 0 4.708-2.946 7.807-7.424 7.99l-.265.008L16 16c-4.8 0-8-3.2-8-8s3.2-8 8-8Zm0 3c-3.143 0-5 1.857-5 5s1.857 5 5 5l.266-.002C19.26 12.953 21 11.153 21 8c0-3.143-1.857-5-5-5Z"
          fill={props.$tint ? TINT[props.$tint]?.primary : colors.GREY_SHADE_7}
        />
      </Icon>
    </Wrapper>
  )
})``

export const Wrapper = styled.div<{ $backgroundColor?: string; $shape: Shape }>`
  ${({ $shape: form }) => {
    if (form === 'rounded') {
      return css`
        border-radius: 100%;
      `
    } else {
      return css`
        border-radius: 6px;
      `
    }
  }}

  ${({ $backgroundColor }) => {
    if ($backgroundColor !== undefined) {
      return css`
        align-items: center;
        background-color: ${$backgroundColor};
        display: flex;
        justify-content: center;
        padding: 8px;
        transition: background-color 0.3s cubic-bezier(0.83, 0, 0.17, 1);
      `
    }
  }}
`
